var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7349 12.6665L17.7367 13.2676C17.9339 13.386 17.9979 13.6419 17.8796 13.8393C17.8444 13.8978 17.7953 13.9469 17.7367 13.9822L10.4275 18.3676C10.1636 18.5259 9.83394 18.5259 9.57003 18.3676L2.26095 13.9822C2.06363 13.8638 1.99964 13.6078 2.11804 13.4105C2.15322 13.3518 2.2023 13.3028 2.26095 13.2676L3.26269 12.6665L9.99878 16.7082L16.7349 12.6665ZM16.7349 8.74984L17.7367 9.35092C17.9339 9.46934 17.9979 9.72525 17.8796 9.92259C17.8444 9.98117 17.7953 10.0303 17.7367 10.0655L9.99878 14.7082L2.26095 10.0655C2.06363 9.94709 1.99964 9.69117 2.11804 9.49384C2.15322 9.43517 2.2023 9.38609 2.26095 9.35092L3.26269 8.74984L9.99878 12.7915L16.7349 8.74984ZM10.4275 1.09044L17.7367 5.4759C17.9339 5.59429 17.9979 5.85024 17.8796 6.04756C17.8444 6.10621 17.7953 6.15529 17.7367 6.19048L9.99878 10.8332L2.26095 6.19048C2.06363 6.07209 1.99964 5.81614 2.11804 5.61882C2.15322 5.56017 2.2023 5.51109 2.26095 5.4759L9.57003 1.09044C9.83394 0.932094 10.1636 0.932094 10.4275 1.09044ZM9.99878 2.77684L4.90489 5.83319L9.99878 8.8895L15.0927 5.83319L9.99878 2.77684Z",
    fill: "#1D0105"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandsIcon);
export default __webpack_public_path__ + "static/media/brands-icon.1ec852e84e10d549b52b537451cff90a.svg";
export { ForwardRef as ReactComponent };